
// Elements we need to manage
const applyCheckbox = document.querySelector('.apply-now-checkbox');
const btn = document.querySelector('.button-container');
const applyForm = document.querySelector('.form-apply');

const dummyFields = {
    "Date of Birth": "01/01/1900",
    "Postcode": "1111",
    "Gender": "Indeterminant/ Intersex/ Unspecified",
    "Email (Confirm)": "fake@fake.com",
    "Study load": "Full Time"
}

var courseListDOM = "";
var locationListDOM = "";
var studyloadListDOM = "";


function applyFormUpdates(bool, btnLabel) {
    if (applyForm) {
        const formClass = applyForm.classList;

        // Update local storage and button label
        localStorage.setItem('is-application', bool);
        jQuery('.form-section').closest('.scfForm').find('.scfSubmitButton').val(btnLabel);
        bool ? formClass.add('visible') : formClass.remove('visible');
        if (bool) {
            // Clear default values from apply-only fields
            var fieldschanged = false;
            // DOB
            if (jQuery("label:contains('Date of Birth')").closest('div').find('input').val() == dummyFields["Date of Birth"]) {
                jQuery("label:contains('Date of Birth')").removeClass('active').closest('div').find('input').val('');
            } else {
                fieldschanged = true;
            }
            // Postcode
            if (jQuery("label:contains('Postcode')").closest('div').find('input').val() == dummyFields["Postcode"]) {
                jQuery("label:contains('Postcode')").removeClass('active').closest('div').find('input').val('');
            } else {
                fieldschanged = true;
            }
            // Gender - clear this if the other fields haven't changed
            if (!fieldschanged) {
                jQuery("label:contains('Gender')").removeClass('active').closest('div').find('select').val('');
            }
            // Email confirm - always clear
            jQuery("label:contains('Email (Confirm)')").removeClass('active').closest('div').find('input').val('');

            // Remove auto-copy function from email field
            jQuery("label:contains('Email')").closest('div').find('input').off('input.emailcopier');

            // Hide message field (not used for applications)
            jQuery("label:contains('Message')").closest('div').closest('div').hide();

            jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Preferred Starting Year')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Course')").closest('div').find('select').rules('add', { required: true });
            jQuery("label:contains('Study load')").closest('div').find('select').rules('add', { required: true });



            // Show asterisks for the fields that are only mandatory on applications
            jQuery("label:contains('Course') .scfRequired").show();
            jQuery("label:contains('Preferred'):contains('Location') .scfRequired").show();
            jQuery("label:contains('Preferred Starting Year') .scfRequired").show();
            jQuery("label:contains('Study load') .scfRequired").show();

        } else {
            // Add dummy values to any blank apply-only fields 
            // DOB
            if (jQuery("label:contains('Date of Birth')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Date of Birth')").closest('div').find('input').val(dummyFields["Date of Birth"]);
            }
            // Postcode
            if (jQuery("label:contains('Postcode')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Postcode')").closest('div').find('input').val(dummyFields["Postcode"]);
            }
            // Gender
            if (jQuery("label:contains('Gender')").closest('div').find('select').val() == '') {
                jQuery("label:contains('Gender')").closest('div').find('select').val(dummyFields["Gender"]);
            }
            // if (jQuery("label:contains('Study load')").closest('div').find('select').val() == '') {
            // jQuery("label:contains('Study load')").closest('div').find('select').val(dummyFields["Study load"]);
            // }
            // Email confirm - set to match email field
            if (jQuery("label:contains('Email')").closest('div').find('input').val() == '') {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('select').val(dummyFields["Email (Confirm)"]);
            } else {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('input').val(jQuery("label:contains('Email')").closest('div').find('input').val());
            }

            // Add function to copy from email to confirm field so enquiries can be submitted
            jQuery("label:contains('Email')").closest('div').find('input').on('input.emailcopier', function () {
                jQuery("label:contains('Email (Confirm)')").closest('div').find('input').val(jQuery(this).val());
            });

            // Show message field (not used for applications)
            jQuery("label:contains('Message')").closest('div').closest('div').show();

            jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').rules('remove', 'required');
            jQuery("label:contains('Preferred Starting Year')").closest('div').find('select').rules('remove', 'required');
            jQuery("label:contains('Course')").closest('div').find('select').rules('remove', 'required');
            // Hide asterisks for the fields that are only mandatory on applications
            jQuery("label:contains('Course') .scfRequired").hide();
            jQuery("label:contains('Preferred'):contains('Location') .scfRequired").hide();
            jQuery("label:contains('Preferred Starting Year') .scfRequired").hide();
            jQuery("label:contains('Study load') .scfRequired").hide();



        }
    }
}

// conditional check for checkbox
function toggleApplication(el) {
    var $checked = jQuery(el).filter(function () {
        return jQuery(this).prop('checked');
    });
    // can change button per form function if necessary
    $checked.val() === 'apply' ?
        applyFormUpdates(true, 'Submit') :
        applyFormUpdates(false, 'Submit');
};

function filterCourseList() {
    // Enable only courses that fall under the currently selected study area

    var courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
    var selectedStudyArea = jQuery("label:contains('Study Area')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    var selectedStudyload = jQuery("label:contains('Study load')").closest('div').find('select option:selected');

    if (jQuery(selectedStudyArea).length > 0 && jQuery(selectedStudyArea).val() != '') {
        var studyAreaName = jQuery(selectedStudyArea).val();
        //remove the course list and replace with the saved one
        jQuery(courseDropdown).remove();
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        //clear the location list while we're at it
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());

        jQuery("label:contains('Preferred'):contains('Location')").removeClass('active');


        //remove courses that aren't in the selected study area
        jQuery("label:contains('Course')").removeClass('active');
        courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
        jQuery(courseDropdown).val([]);
        jQuery(courseDropdown).find("option").each(function () {
            if (jQuery(this).val() != '') {
                var valueArray = jQuery(this).val().split("|");
                if (valueArray.length > 1) {
                    var studyItems = valueArray[1].split(/\s*,\s*/);
                    if (studyItems.indexOf(studyAreaName) == -1) {
                        jQuery(this).remove();
                    }
                }
            }
        });
    } else {
        //remove current filtering
        jQuery(courseDropdown).remove();
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());
    }
}

function filterStudyloadList() {
    // Enable only courses that fall under the currently selected study load

    var courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
    var selectedStudyArea = jQuery("label:contains('Study Area')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    var selectedStudyload = jQuery("label:contains('Study load')").closest('div').find('select option:selected');

    if (jQuery(selectedStudyload).length > 0 && jQuery(selectedStudyload).val() != '') {
        var studyloadName = jQuery(selectedStudyload).val();
        //remove the course list and replace with the saved one
        jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        //clear the location list while we're at it

        //remove courses that aren't in the selected study area
        jQuery("label:contains('Course')").removeClass('active');
        courseDropdown = jQuery("label:contains('Course')").closest('div').find('select');
        jQuery(courseDropdown).val([]);
        jQuery(courseDropdown).find("option").each(function () {
            if (jQuery(this).val() != '') {
                var valueArray = jQuery(this).val().split("|");
                if (valueArray.length > 1) {
                    var studyItems = valueArray[1].split(/\s*,\s*/);
                    if (studyItems.indexOf(studyloadName) == -1) {
                        jQuery(this).remove();
                    }
                }
            }
        });
        // } else {
        // //remove current filtering
        // jQuery(courseDropdown).remove();
        // jQuery("label:contains('Course')").closest('div').find('.scfDropListGeneralPanel').append(courseListDOM.clone());
        // jQuery(locationDropdown).remove();
        // jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());
        // }
    }
}







function filterLocation() {
    // Enable only locations that are valid for the currently selected course

    var selectedCourse = jQuery("label:contains('Course')").closest('div').find('select option:selected');
    var locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
    if (jQuery(selectedCourse).length > 0 && jQuery(selectedCourse).val() != '') {

        //remove the select list and replace with the saved one
        jQuery(locationDropdown).remove();
        jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('.scfDropListGeneralPanel').append(locationListDOM.clone());

        jQuery("label:contains('Preferred'):contains('Location')").removeClass('active');
        locationDropdown = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select');
        jQuery(locationDropdown).val([]);
        var valueArray = jQuery(selectedCourse).val().split("|");
        if (valueArray.length >= 3) {
            var locationItems = valueArray[2].split(/\s*,\s*/);
            jQuery(locationDropdown).find("option").each(function () {
                if (jQuery(this).val() != '') {
                    if (locationItems.indexOf(jQuery(this).val()) == -1) {
                        jQuery(this).remove();
                    }
                }
            });
        }
    }
}

jQuery(document).ready(function () {
    var courseguid = '';

    // Set up enquire/apply form on page load
    if (applyForm) {
        // Get the default values for the mandatory-on-apply fields and store them in a dictionary
        // (so we can restore them later if necessary)
        /*for (var fieldName in dummyFields) {
            var fieldInput = jQuery("label:contains('" + fieldName + "')").closest('div').find('input,select');
            dummyFields[fieldName] = fieldInput.val();
        }*/
        //hide the dummy course option
        jQuery("label:contains('Course')").closest('div').find('select option:contains("None selected")').remove();

        //save the full course list for filtering
        courseListDOM = jQuery("label:contains('Course')").closest('div').find('select').clone();
        studyloadListDOM = jQuery("label:contains('Study load')").closest('div').find('select').clone();

        locationListDOM = jQuery("label:contains('Preferred'):contains('Location')").closest('div').find('select').clone();


        //check the register/apply radio (default is register - may be apply on postback)
        toggleApplication(jQuery('.enquiry-type input[type="radio"]'));

        jQuery('.enquiry-type input[type="radio"]').change(function () {
            toggleApplication(this)
        })

        // Disable switch to apply if they haven't come from the course page
        jQuery('.enquiry-type').hide();

        // Add blank option to course list and preselect course if provided in query string
        /*jQuery("label:contains('Course')").closest('div').find('select').prepend("<option value='' selected='selected'></option>");
        jQuery("label:contains('Course')").removeClass('active');*/

        // handle the subject area querystring parameter, if provided
        if (jQuery.urlParam('cfid') != null && jQuery.urlParam('cfid') != "") {
            careerguid = decodeURIComponent(jQuery.urlParam('cfid'));
            // select the career field from the list
            jQuery("label:contains('Study Area')").closest('div').find('select').val(careerguid);

            if (jQuery("label:contains('Study Area')").closest('div').find('select option:selected').length > 0) {
                jQuery("label:contains('Study Area')").addClass('active');
                filterCourseList();
            }
            if (jQuery("label:contains('Study load')").closest('div').find('select option:selected').length > 0) {
                jQuery("label:contains('Study load')").addClass('active');
            }

        }

        // handle the course guid querystring parameter, if provided
        if (jQuery.urlParam('id') != null && jQuery.urlParam('id') != "") {
            courseguid = decodeURIComponent(jQuery.urlParam('id'));
            // select the course from the list
            jQuery("label:contains('Course')").closest('div').find('select option').each(function () {
                if (jQuery(this).val().indexOf(courseguid) > -1) {
                    jQuery(this).attr('selected', 'selected');
                    jQuery(this).closest('.scfDropListBorder').find('label').addClass('active');
                    //if no career field provided, pick one from the course
                    if (jQuery("label:contains('Study Area')").closest('div').find('select').val() == "") {
                        var careerfieldname = jQuery(this).val().split("|")[1].split(",")[0];
                        jQuery("label:contains('Study Area')").closest('div').find('select option[value=""]').removeAttr('selected');
                        jQuery("label:contains('Study Area')").closest('div').find('select option[value="' + careerfieldname + '"]').attr('selected', 'selected')
                        jQuery("label:contains('Study Area')").closest('div').find('input[type="hidden"]').val(careerfieldname);
                        jQuery("label:contains('Study Area')").addClass('active');
                    }
                    //filter the campus dropdown
                    filterLocation();
                }
            });

            jQuery('.enquiry-type').show(); //enable the checkbox to switch from register to apply

        }
        else {
            // Check mandatory radio button
            jQuery('.enquiry-type input[type="radio"]').first().prop("checked", true);
        }

        // Add filter functions to select lists
        /*jQuery("label:contains('Study Area')").closest('div').find('select').change(function () {*/
        jQuery("label:contains('Study Area')").closest('div').on('change', 'select', function () {
            filterCourseList();
            filterStudyloadList();
        });

        /*jQuery("label:contains('Course')").closest('div').find('select').change(function () {*/
        jQuery("label:contains('Course')").closest('div').on('change', 'select', function () {
            filterLocation();
        });

        // Remove confirm email validation message if email not provided
        var hideConfirm = false;
        jQuery('.scfValidationSummary ul li').each(function () {
            if (jQuery(this).html() == "You must provide an email address") {
                hideConfirm = true;
            }
        });
        if (hideConfirm) {
            jQuery('.scfValidationSummary ul li').each(function () {
                if (jQuery(this).html() == "You must confirm your email address") {
                    jQuery(this).hide();
                }
            });
        }

    }
});
var selectors = {
    basicInfo: 'div.first-name input, div.last-name input, div.email-address input',
    studentID: 'div.student-id input',
    responsibleDepartment: 'div.responsible-department input',
    ageConsent: 'input.ageconsent-checkbox',
    address: 'textarea.street-address, div.suburb input, div.postcode input',
    phone: 'div.daytime-phone input.scfTelephoneTextBox',
    international: '.international-student-checkbox'
};

var ALL_FIELDS = selectors.basicInfo + ',' +
    selectors.studentID + ',' +
    selectors.responsibleDepartment + ',' +
    selectors.ageConsent + ',' +
    selectors.address + ',' +
    selectors.phone + ',' +
    selectors.international;


function submitComplaintsRegister() {
    setTimeout(function () {
        applyUIRules();
    }, 200);
}


function clearNameField() {
    var field = jQuery('div.first-name input');
    var wrapper = field.closest('.scfSingleLineTextBorder');

    field.css('border-color', '').removeClass('input-validation-error');
    wrapper.css('border-color', '').removeClass('input-validation-error');

    wrapper.find('.scfValidatorRequired, .scfRequired').hide();

    wrapper.find('.field-validation-error')
        .removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .empty()
        .hide();
}


function clearField(selector) {
    var field = jQuery(selector);
    if (!field.length) return;

    var wrapper = field.closest(
        '.scfSingleLineTextBorder, ' +
        '.scfMultipleLineTextBorder, ' +
        '.scfDropListBorder, ' +
        '.scfCheckboxBorder, ' +
        '.scfTelephoneBorder'
    );

    field.css('border-color', '').removeClass('input-validation-error');
    wrapper.css('border-color', '').removeClass('input-validation-error');

    wrapper.find('.scfValidatorRequired, .scfRequired').hide();

    wrapper.find('.field-validation-error')
        .removeClass('field-validation-error')
        .addClass('field-validation-valid')
        .empty()
        .hide();

    var form = field.closest('form');
    var validator = form.data('validator');

    if (validator) {
        var name = field.attr('name');
        delete validator.invalid[name];

        validator.errorList = validator.errorList.filter(function (e) {
            return e.element.name !== name;
        });

        validator.successList.push(name);
        validator.showErrors();
    }
}



function removeValidators(selector) {
    var fields = jQuery(selector);

    fields.removeAttr([
        'data-val', 'data-val-required', 'data-val-regex',
        'data-val-number', 'data-val-email',
        'required', 'aria-required'
    ].join(' '));

    fields.each(function () {
        try { jQuery(this).rules('remove'); } catch (e) { }
    });

    var form = fields.closest('form');
    var validator = form.data('validator');

    fields.each(function () {
        var name = jQuery(this).attr('name');
        if (validator && validator.settings && validator.settings.rules[name]) {
            delete validator.settings.rules[name];
        }
    });

    fields
        .removeClass('input-validation-error')
        .closest('.scfSingleLineTextBorder, .scfMultipleLineTextBorder, .scfDropListBorder, .scfCheckboxBorder, .scfTelephoneBorder')
        .removeClass('input-validation-error')
        .css('border-color', '')
        .find('.scfRequired, .scfValidatorRequired, .field-validation-error, .field-validation-valid')
        .hide();
}


function addValidators(selector) {
    var fields = jQuery(selector);

    fields.each(function () {
        var field = jQuery(this);
        var fieldName = field.attr("name");

        field.attr({
            'data-val': 'true',
            'data-val-required': 'This field is required',
            'required': 'required',
            'aria-required': 'true'
        });

        try { field.rules('add', { required: true }); } catch (e) { }

        var container = field.closest(
            '.scfSingleLineTextBorder, .scfMultipleLineTextBorder, .scfTelephoneBorder, .scfCheckboxBorder'
        );

        var label = container.find('label');

        if (label.find('.scfRequired').length === 0 &&
            label.find('.scfValidatorRequired').length === 0) {
            label.append(' <span class="scfRequired">*</span>');
        }

        var validator = container.find(
            '.scfValidatorRequired, .field-validation-error, .field-validation-valid, .scfValidator'
        );

        if (validator.length === 0) {
            validator = jQuery(
                '<span class="scfValidatorRequired" data-valmsg-for="' +
                fieldName +
                '" data-valmsg-replace="true"></span>'
            );
            container.append(validator);
        }

        label.find('.scfRequired').css('display', 'inline-block');
        container.find('.scfValidatorRequired').css('display', 'inline-block');
    });
}



function applyUIRules() {

    // Member of Public
    if (jQuery('.studenttype-droplist select').val() === 'Member of the Public') {

        jQuery('.student-id,.responsible-department,.campus, .course-code, .course-name,.company-name, .student-full-name').hide();
        jQuery('.epsilon-employer-code').hide();
        jQuery('.someone-else,.international-student-checkbox').closest('div.scfCheckboxBorder').hide();
        jQuery('.unit-code-name').closest('div.scfMultipleLineTextBorder').hide();

        if (jQuery('.compliant-or-concern select').val() === 'Concern') {

            removeValidators(
                selectors.basicInfo + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone
            );

        } else if (jQuery('.compliant-or-concern select').val() === 'Complaint') {

            addValidators(
                selectors.basicInfo + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone + ',' +
                selectors.international
            );
        }
    }

    // Parent/Guardian
    if (jQuery('.studenttype-droplist select').val() === 'Parent/Guardian') {

        jQuery('.company-name,.epsilon-employer-code').hide();
        jQuery('.unit-code-name').closest('div.scfMultipleLineTextBorder').hide();

        addValidators(selectors.international + ',' + '.someone-else');

        if (jQuery('.compliant-or-concern select').val() === 'Concern') {

            removeValidators(
                selectors.basicInfo + ',' +
                selectors.address + ',' +
                selectors.phone
            );

        } else {
            addValidators(
                selectors.basicInfo + ',' +
                selectors.address + ',' +
                selectors.phone
            );
        }
    }

    // Prospective Student
    if (jQuery('.studenttype-droplist select').val() === 'Prospective Student') {

        jQuery('.someone-else,.student-id,.campus, .course-code, .course-name, .company-name, .student-full-name').hide();
        jQuery('.epsilon-employer-code').hide();
        jQuery('.unit-code-name').closest('div.scfMultipleLineTextBorder').hide();

        addValidators(
            selectors.basicInfo + ',' +
            selectors.studentID + ',' +
            selectors.ageConsent + ',' +
            selectors.address + ',' +
            selectors.phone
        );
    }

    // Employer
    if (jQuery('.studenttype-droplist select').val() === 'Employer') {

        jQuery('.unit-code-name').closest('div.scfMultipleLineTextBorder').hide();
        jQuery('.international-student-checkbox').closest('div.scfCheckboxBorder').hide();

        addValidators(
            'div.company-name input' + ',' +
            '.someone-else' + ',' +
            selectors.phone + ',' +
            selectors.basicInfo + ',' +
            selectors.address
        );
    }

    // Past Student
    if (jQuery('.studenttype-droplist select').val() === 'Past Student') {

        jQuery('.company-name, .student-full-name').hide();
        jQuery('.epsilon-employer-code').hide();
        jQuery('.unit-code-name').closest('div.scfMultipleLineTextBorder').hide();
        jQuery('.someone-else').closest('div.scfCheckboxBorder').hide();

        addValidators(
            'div.responsible-department input' + ',' +
            selectors.international + ',' +
            'div.campus input'
        );

        if (jQuery('.compliant-or-concern select').val() === 'Concern') {

            removeValidators(
                selectors.basicInfo + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone
            );

        } else {
            addValidators(
                selectors.basicInfo + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone
            );
        }
    }

    // Current Student
    if (jQuery('.studenttype-droplist select').val() === 'Current Student') {

        jQuery('.company-name, .student-full-name').hide();
        jQuery('.epsilon-employer-code').hide();
        jQuery('.someone-else').closest('div.scfCheckboxBorder').hide();

        addValidators('div.campus input, div.responsible-department input');

        if (jQuery('.compliant-or-concern select').val() === 'Concern') {

            removeValidators(
                selectors.basicInfo + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone + ',' +
                selectors.studentID
            );

        } else if (jQuery('.compliant-or-concern select').val() === 'Complaint') {

            addValidators(
                selectors.basicInfo + ',' +
                selectors.studentID + ',' +
                selectors.ageConsent + ',' +
                selectors.address + ',' +
                selectors.phone + ',' +
                selectors.international
            );
        }
    }
}



jQuery(function () {
    setTimeout(function () {
        initialHide();
    }, 200);
});

function initialHide() {
    jQuery('.studenttype-droplist, .compliant-or-concern').show();
    jQuery('.scfForm1').children().not('.studenttype-droplist, .compliant-or-concern').hide();
}



jQuery(document).on('change', '.compliant-or-concern select,.concern-as-anonymous', function () {

    jQuery('.scfForm1').children().show();

    if (jQuery('.compliant-or-concern select').val() === 'Complaint') {
        jQuery('.concern-as-anonymous').closest('.scfCheckboxBorder').hide();
        jQuery('.concern-as-anonymous').prop('checked', false);
        removeValidators('.concern-as-anonymous');
    } else if (jQuery('.compliant-or-concern select').val() === 'Concern') {

        addValidators('.concern-as-anonymous');
    }
    applyUIRules();
});



jQuery(document).on('change', '.studenttype-droplist select', function () {
    initialHide();
    jQuery('.concern-as-anonymous').prop('checked', false);
    jQuery('.compliant-or-concern select').val("");
});


function setupLookup(labelText, apiUrl, resultKey, listClass, idField, nameField, multiSelect) {

    multiSelect = (typeof multiSelect === "undefined") ? false : multiSelect;

    var textbox = jQuery('label:contains("' + labelText + '")')
        .closest('.scfSingleLineTextBorder')
        .find('input.scfSingleLineTextBox');

    if (!textbox.length) {
        console.warn(labelText + ' textbox not found');
        return;
    }

    var dataList = [];
    var isLoaded = false;
    var paramName = apiUrl.split('/').pop();

    // API call
    jQuery.ajax({
        url: apiUrl,
        type: 'GET',
        success: function (data) {
            try {
                dataList = JSON.parse(data[resultKey]);
                isLoaded = true;
            } catch (e) {
                console.error("Invalid JSON from API:", data);
            }
        },
        error: function () {
            console.error(labelText + ' lookup API failed');
        }
    });

    // Show suggestions on click
    textbox.on("click", function () {
        if (!isLoaded || dataList.length === 0) return;
        showSuggestions(textbox, dataList, listClass, idField, nameField, multiSelect);
    });

    // Filter suggestions on keyup
    textbox.on("keyup", function () {
        if (!isLoaded || dataList.length === 0) return;

        var query = textbox.val().toLowerCase();

        var filtered = dataList.filter(function (item) {
            return item[nameField].toLowerCase().indexOf(query) !== -1;
        });

        showSuggestions(textbox, filtered, listClass, idField, nameField, multiSelect);
    });
}



function showSuggestions(textbox, results, listClass, idField, nameField, multiSelect) {

    jQuery('.' + listClass).remove();

    var campusRaw = jQuery('div.campus input').val();
    var campusValue = campusRaw ? campusRaw.trim().toLowerCase() : "";

    // Filter Responsible Department when Campus = Online
    if (listClass === "lookup-results" && campusValue === "online") {
        results = results.filter(function (item) {
            return item[nameField] &&
                item[nameField].toLowerCase().indexOf("online") !== -1;
        });
    }

    // No results
    if (!results.length) {
        var noList = jQuery('<ul class="' + listClass + '"><li class="no-results">No results found</li></ul>');
        textbox.after(noList);

        jQuery(document).on("click", function (e) {
            if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
                noList.remove();
            }
        });

        return;
    }

    // Create list
    var list = jQuery('<ul class="' + listClass + '"></ul>');

    // Selected values
    var selectedValues = textbox.val()
        ? textbox.val().split(',').map(function (v) { return v.trim(); }).filter(function (v) { return v; })
        : [];

    // Multi-select close button
    if (multiSelect) {
        var closeBtn = jQuery('<div class="lookup-close">×</div>');
        list.prepend(closeBtn);

        closeBtn.on("click", function (e) {
            e.stopPropagation();
            list.remove();
        });
    }

    // Build list items
    results.forEach(function (item) {
        var isSelected = selectedValues.indexOf(item[nameField]) !== -1;

        var li = jQuery(
            '<li data-id="' + item[idField] + '">' +
            '<input type="checkbox" class="lookup-check" ' + (isSelected ? 'checked' : '') + '>' +
            '<span>' + item[nameField] + '</span>' +
            '</li>'
        );

        list.append(li);
    });

    textbox.after(list);

    // Multiselect droplist
    if (multiSelect) {

        list.on("click", "li", function (e) {
            e.stopPropagation();

            var checkbox = jQuery(this).find(".lookup-check");
            checkbox.prop("checked", !checkbox.prop("checked"));

            var value = jQuery(this).find("span").text();

            if (checkbox.prop("checked")) {
                if (selectedValues.indexOf(value) === -1) {
                    selectedValues.push(value);
                }
            } else {
                selectedValues = selectedValues.filter(function (v) {
                    return v !== value;
                });
            }

            textbox.val(
                selectedValues
                    .map(function (v) { return v.trim(); })
                    .filter(function (v) { return v.length > 0; })
                    .join(", ")
            );
        });

        jQuery(document).on("click", function (e) {
            if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
                list.remove();
            }
        });

        return;
    }

    // single select droplist
    list.on("click", "li", function () {
        textbox.val(jQuery(this).find("span").text());

        var campusVal = jQuery('div.campus input').val();
        if (campusVal && campusVal.toLowerCase() === 'online') {
            var deptTextbox = jQuery('div.responsible-department input');
            deptTextbox.val("Online");
        }

        list.remove();
    });

    jQuery(document).on("click", function (e) {
        if (!jQuery(e.target).closest('.' + listClass + ', .scfSingleLineTextBox').length) {
            list.remove();
        }
    });
}
jQuery(function () {

    setupLookup(
        "Responsible Department",
        "/StatusService.svc/StatusService/CaseResponsibleDepartment",
        "CaseResponsibleDepartmentResult",
        "lookup-results",
        "DepartmentId",
        "DepartmentName"
    );

    setupLookup(
        "Course Name",
        "/StatusService.svc/StatusService/CaseCourse",
        "CaseCourseResult",
        "lookup-results",
        "AcademicprogramId",
        "Academicprogramname"
    );

    setupLookup(
        "Campus",
        "/StatusService.svc/StatusService/CaseCampus",
        "CaseCampusResult",
        "lookup-results",
        "CampusId",
        "Campusname"
    );

    setupLookup(
        "Complaint topic/​s",
        "/StatusService.svc/StatusService/CaseTheme",
        "CaseThemeResult",
        "lookup-results-complaint",
        "ThemeId",
        "Themename",
        true
    );



});



